import React, { useState } from 'react';
import './BackgroundImage.css';
import { STATIC_ICONS } from '../Constants';

const BackgroundImage = ({ draggable, imageUrl, file }) => {
  const [cursorState, setCursorState] = useState('idle');
  const isFileObject = file instanceof Blob;

  const cursorClass = draggable
    ? (cursorState === 'grabbing' ? 'background-image--grabbing' : 'background-image--grab')
    : 'background-image--pointer';

  return (
    <div
      className={[
        "image-container",
        "background-image",
        cursorClass,
      ].filter(Boolean).join(" ")}
      onMouseDown={() => draggable && setCursorState('grabbing')}
      onMouseUp={() => draggable && setCursorState('grab')}
      onMouseLeave={() => draggable && setCursorState('grab')}
      draggable={draggable}
      onDragStart={(e) => {
        const id = e.target.closest('.widget')?.id;
        if (!id) return;
        const rect = e.target.getBoundingClientRect();
        const offsetX = e.clientX - rect.x;
        const offsetY = e.clientY - rect.y;
        let dragData = `background-image;${id};${offsetX};${offsetY};${id.startsWith('base') ? 'add' : 'move'}`;
        e.dataTransfer.setData('text/plain', dragData);
      }}
    >
      <div className="background-image-container">
        {isFileObject ? (
          <img
            src={URL.createObjectURL(file)}
            alt="Background"
            className="background-image-preview"
          />
        ) : imageUrl ? (
          <img
            src={STATIC_ICONS + imageUrl}
            alt="Background"
            className="background-image-preview"
          />
        ) : (
          <div className="placeholder-image">
            No Image Selected
          </div>
        )}
      </div>
    </div>
  );
};

export default BackgroundImage;
